// Mirrors backend.inspiration.run_key so a new (or reclassified) latest
// run refetches the one-liner without a hard reload.
function isWalkActivity(run) {
  const sport = String(run.sport_type || '').replace(/_/g, '').toLowerCase();
  const wtype = String(run.workout_type || '').toLowerCase();
  return sport === 'walk' || sport === 'hike' || wtype === 'walk';
}

export function latestInspirationRunKey(runs) {
  const run = (runs || []).find((row) => !isWalkActivity(row)) || null;
  if (!run) return '';
  const sid = run.strava_activity_id || run.id || '';
  const start = run.start_date || '';
  const wtype = run.workout_type || 'unk';
  return `${sid}:${start}:${wtype}`;
}
